import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=0a2b1bc6"
import script from "./Vendors.vue?vue&type=script&lang=js"
export * from "./Vendors.vue?vue&type=script&lang=js"
import style0 from "./Vendors.vue?vue&type=style&index=0&id=0a2b1bc6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports